import * as THREE from 'three';


export const PerspectiveCameraForResizableWindow = (cameraFOV,
    howNearToRender,
    howFarToRender,
    renderer) => {

    const camera = new THREE.PerspectiveCamera(
        cameraFOV,
        window.innerWidth/window.innerHeight,
        howNearToRender,
        howFarToRender);

    renderer.setPixelRatio(window.devicePixelRatio);

    renderer.setSize(window.innerWidth, window.innerHeight);
    //camera.rotation.y = 45 * Math.PI / 180;
    camera.aspect = renderer.domElement.clientWidth / renderer.domElement.clientHeight;
    camera.updateProjectionMatrix();

    window.addEventListener('resize', () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
        camera.aspect = renderer.domElement.clientWidth / renderer.domElement.clientHeight;
        camera.updateProjectionMatrix();
    });

    return camera;
}

export const handleMouseMovement = (mouseX, mouseY, cameraOrientationState) =>{
    const now = performance.now()

    cameraOrientationState.lastMouseMoveTime = now;

    const rotationScale = 0.05;

    cameraOrientationState.pitchAngle = -(mouseY * rotationScale) * Math.PI;
    cameraOrientationState.yawAngle = -(mouseX * rotationScale) * Math.PI;

    cameraOrientationState.startingPitchAngleForCurrentCoordinates = cameraOrientationState.previousPitchAngle;
    cameraOrientationState.startingYawAngleForCurrentCoordinates = cameraOrientationState.previousYawAngle;

}

export const handleCameraRotation = (camera, cameraOrientationState) =>
{
    const now = performance.now();

    const timeElapsed = now - cameraOrientationState.lastMouseMoveTime;

    if(cameraOrientationState.cameraMoving){

    }
    else {
        if (timeElapsed < cameraOrientationState.movementDuration){

            const timeLeftPercentage = timeElapsed / cameraOrientationState.movementDuration;
            const minimumDegreeOfChange = 0.5;
    
            let interpolationFactor = Math.max(timeLeftPercentage, minimumDegreeOfChange);
            const interpolatedPitchAngle = (1 - interpolationFactor) * cameraOrientationState.startingPitchAngleForCurrentCoordinates + interpolationFactor * cameraOrientationState.pitchAngle;
            const interpolatedYawAngle = (1 - interpolationFactor) * cameraOrientationState.startingYawAngleForCurrentCoordinates + interpolationFactor * cameraOrientationState.yawAngle;
    
            camera.rotation.x = interpolatedPitchAngle;
            camera.rotation.y = interpolatedYawAngle;
    
            cameraOrientationState.previousPitchAngle = interpolatedPitchAngle;
            cameraOrientationState.previousYawAngle = interpolatedYawAngle;
    
        }         
    }

}